// Orthographic globe projection — pure math, zero DOM. Portable to the RN port.
//
// Convention: lat/lon in degrees. lon 0 faces the viewer (+z). East = +x, North = +y.
// The render loop rotates the sphere about Y (spin / auto-rotation) then about X (a
// fixed aesthetic tilt). For the hot dot loop we inline this math over typed arrays;
// `project()` is the same transform for the handful of weather points + the user pin.

export interface Vec3 {
  x: number
  y: number
  z: number
}

/** lat/lon (deg) → unit sphere vector. */
export function latLonToVec3(lat: number, lon: number): Vec3 {
  const phi = (lat * Math.PI) / 180
  const lam = (lon * Math.PI) / 180
  const cphi = Math.cos(phi)
  return { x: cphi * Math.sin(lam), y: Math.sin(phi), z: cphi * Math.cos(lam) }
}

// The full spin→tilt→roll→orthographic transform is performed inline in DotGlobe's
// hot render loop (over typed arrays, for the weather points, and for the user pin)
// so every projected element stays in exact agreement. `latLonToVec3` + `spinForLon`
// are the shared pure primitives.

/** Spin (radians) that brings a given longitude to face the viewer (z maximal). */
export function spinForLon(lon: number): number {
  return (-lon * Math.PI) / 180
}
